module.exports = __webpack_public_path__ + "images/pipeline_logo.png";